import { metaAccount } from '@/router/meta-config'
const permissionKey = 'ROUTE'

export default [
  // routes
  {
    path: '/routes',
    name: 'page-routes',
    component: () => import('@/pages/routes'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/route/new',
    name: 'page-route-new',
    component: () => import('@/pages/route'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/route/:id',
    name: 'page-route',
    component: () => import('@/pages/route'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
